import { TextField } from "@mui/material";

import { RobotoIconButton } from "@/shared/components";
import { SwapHorizIcon } from "@/shared/foundation/icons/mui";

import styles from "./EntityConfig.module.css";

interface Props {
  /** The color at the gradient's low end, as a `#rrggbb` hex string. */
  colorLow: string;
  /** The color at the gradient's high end, as a `#rrggbb` hex string. */
  colorHigh: string;
  /** Called with the new low color: a pick in its field, or the swap. */
  onColorLowChange: (color: string) => void;
  /** Called with the new high color: a pick in its field, or the swap. */
  onColorHighChange: (color: string) => void;
}

/**
 * A gradient's two color pickers, low end then high end, as one row with a
 * button between them that swaps the two: the vector field's and the point
 * cloud's gradients are picked the same way.
 */
export function GradientColorFields({
  colorLow,
  colorHigh,
  onColorLowChange,
  onColorHighChange,
}: Props) {
  return (
    <div className={styles.fieldRow}>
      <TextField
        label="Low Color"
        type="color"
        size="small"
        margin="dense"
        value={colorLow}
        onChange={(e) => onColorLowChange(e.target.value)}
        InputLabelProps={{ className: styles.input }}
        InputProps={{ className: styles.input }}
        inputProps={{ className: styles.input }}
        className={styles.scaleField}
      />
      <RobotoIconButton
        aria-label="Swap colors"
        title="Swap colors"
        size="small"
        className={styles.swapButton}
        onClick={() => {
          onColorLowChange(colorHigh);
          onColorHighChange(colorLow);
        }}
      >
        <SwapHorizIcon fontSize="small" />
      </RobotoIconButton>
      <TextField
        label="High Color"
        type="color"
        size="small"
        margin="dense"
        value={colorHigh}
        onChange={(e) => onColorHighChange(e.target.value)}
        InputLabelProps={{ className: styles.input }}
        InputProps={{ className: styles.input }}
        inputProps={{ className: styles.input }}
        className={styles.scaleField}
      />
    </div>
  );
}
